document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var hasOptions = btn.getAttribute('data-has-options') === 'true';
      if (hasOptions) {
        window.location.href = btn.getAttribute('data-product-url');
        return;
      }

      var productId = btn.getAttribute('data-product-id');
      if (!productId) return;

      btn.textContent = 'Ajout...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: productId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Ajouté ✓';
          if (window.refreshCartDrawer) {
            window.refreshCartDrawer().then(function () {
              if (window.openCartDrawer) window.openCartDrawer();
            });
          }
          setTimeout(function () { btn.textContent = 'Ajouter au panier'; }, 1800);
        })
        .catch(function () {
          btn.textContent = 'Voir le produit';
        });
    });
  });

});
